import Immutable from 'immutable'

import {
  createUserFromCreator,
  createUserFromRelationship,
  createUserFromUser,
} from '../../../records/User'

import { constants as clientConstants } from '../client'
import * as signupConstants from '../signup/constants'

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  users: Immutable.Set(),
})

function buildUsersFromClientResponse(oldUsers, clients) {
  const relationships = clients.reduce(
    (rel, client) => (client.relationships
      ? rel.union(client.relationships)
      : rel),
    Immutable.Set(),
  )

  return relationships.reduce((users, relationship) => {
    const user = createUserFromRelationship(relationship)

    return replaceUser(users, user)
  }, oldUsers)
}

function buildUsersFromSignupResponse(oldUsers, signups) {
  return signups.reduce((users, signup) => {
    users = replaceUser(users, createUserFromCreator(signup))
    if (signup.user) {
      users = replaceUser(users, createUserFromUser(signup.user))
    }

    if (!signup.stateTransitions) {
      return users
    }

    return signup.stateTransitions.reduce(
      (tUsers, transition) =>
        replaceUser(tUsers, createUserFromCreator(transition)),
      users,
    )
  }, oldUsers)
}

function replaceUser(users, user) {
  if (!user) {
    return users
  }

  return users
    .filter(search => search.get('id') !== user.get('id'))
    .add(user)
}

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case clientConstants.RECEIVE_CLIENTS:
      return state.set('users', buildUsersFromClientResponse(state.get('users'), payload.clients))

    case signupConstants.RECEIVE_SIGNUPS:
      return state.set('users', buildUsersFromSignupResponse(state.get('users'), payload.signups))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/user/index.js